import "./App.css";
import { useState } from "react";
import {
  BrowserRouter as Router,
  Routes as Switch,
  Route,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import About from "./components/About";
import NotFound404 from "./components/NotFound404";
import Footer from "./components/Footer";
// eslint-disable-next-line
import LoadingBar from "./components/LoadingBar";
import NotesTable from "./components/NotesTable";
import NoteState from "./context/notes/NoteState";
import AddNote from "./components/AddNote";
import EditNote from "./components/EditNote";
import Alert from "./components/Alert";
import Signup from "./components/Signup";
import Login from "./components/Login";
import YourAccount from "./components/YourAccount";
import SetNewPassword from "./components/SetNewPassword";

function App() {
  // Theme Setter State
  let initialTheme;

  if(localStorage.getItem('theme')==="light"){
    initialTheme = "light"
  }else{
    initialTheme = "dark"
    document.body.style.backgroundColor = "black";
  }

  const [theme, setTheme] = useState(initialTheme);

  const handleThemeChanger = () => {
    if (theme === "light") {
      setTheme("dark");
      document.body.style.backgroundColor = "black";
      localStorage.setItem('theme', 'dark')
    } else {
      setTheme("light");
      document.body.style.backgroundColor = "white";
      localStorage.setItem('theme', 'light')
    }
  };

  // Loading Bar Intregating
  // eslint-disable-next-line
  const [loadingBar, setLoadingBar] = useState(true);

  const showLoading = () => {
    setLoadingBar(true);
  };

  const completeLoading = () => {
    let loadingBarDiv = document.getElementById("loadingBarDiv");
    loadingBarDiv.className = "completeLoading";
    setTimeout(() => {
      loadingBarDiv.className = "loadingBar";
      setLoadingBar(null);
    }, 1000);
  };

  // Alert Intregating
  const [alert, setAlert] = useState(null);

  const showAlert = (type, msgStatus, mainMsg) => {
    setAlert({
      type:type,
      msgStatus:msgStatus,
      mainMsg:mainMsg
    });
    setTimeout(()=>{
      setAlert(null)
    },1500)
  }

  return (
    <>
      <NoteState showAlert={showAlert} showLoading={showLoading} completeLoading={completeLoading}>
        <Router>
          <LoadingBar loadingBar={loadingBar}/>
          <Navbar theme={theme} themeChanger={handleThemeChanger} />
          <Alert alert={alert}/>
          <div className="container pb-5">
            <Switch>
              <Route
                exact
                path="/"
                element={
                  <NotesTable
                    key="notestable"
                    title="NoteBoss - Cloud Based Notes Taking App"
                    theme={theme}
                    showAlert= {showAlert}
                  />
                }
              />
              <Route
                exact
                path="/addNote"
                element={
                  <AddNote
                    key="addNote"
                    title="Add Notes - NoteBoss"
                    showLoading={showLoading}
                    completeLoading={completeLoading}
                    theme={theme}
                  />
                }
              />
              <Route
                exact
                path="/editNote"
                element={
                  <EditNote
                    key="editNote"
                    title="Edit Notes - NoteBoss"
                    showLoading={showLoading}
                    completeLoading={completeLoading}
                    theme={theme}
                    showAlert={showAlert}
                  />
                }
              />
              <Route
                exact
                path="/about"
                element={
                  <About
                    key="about"
                    title="About - NoteBoss"
                    showLoading={showLoading}
                    completeLoading={completeLoading}
                    theme={theme}
                  />
                }
              />
              <Route
                exact
                path="/auth/login"
                element={
                  <Login
                    key="login"
                    title="Login - NoteBoss"
                    showLoading={showLoading}
                    completeLoading={completeLoading}
                    theme={theme}
                    showAlert={showAlert}
                  />
                }
              />
              <Route
                exact
                path="/auth/signup"
                element={
                  <Signup
                    key="signup"
                    title="SignUp - NoteBoss"
                    showLoading={showLoading}
                    completeLoading={completeLoading}
                    theme={theme}
                    showAlert={showAlert}
                  />
                }
              />
              <Route
                exact
                path="/auth/setnewpass"
                element={
                  <SetNewPassword
                    key="setnewpass"
                    title="Set New Password - NoteBoss"
                    showLoading={showLoading}
                    completeLoading={completeLoading}
                    theme={theme}
                    showAlert={showAlert}
                  />
                }
              />
              <Route
                exact
                path="/youraccount"
                element={
                  <YourAccount
                    key="youraccount"
                    title="Update Account Details - NoteBoss"
                    showLoading={showLoading}
                    completeLoading={completeLoading}
                    theme={theme}
                    showAlert={showAlert}
                  />
                }
              />
              <Route
                path="*"
                element={
                  <NotFound404
                    key="notFound404"
                    title="404 Not Found!!! - NoteBoss"
                    showLoading={showLoading}
                    completeLoading={completeLoading} 
                    theme = {theme}
                  />
                }
              />
            </Switch>
          </div>
          <Footer theme={theme} />
        </Router>
      </NoteState>
    </>
  );
}

export default App;
